import Box from '@mui/material/Box'
import { HOC } from '@k3/core/src/lib/components/pages/Extensions'
import {
  NewVariable,
  VariableT,
} from '@k3/core/src/lib/types/variable.interface'

export const extendVariableLabel: HOC<{
  variable: NewVariable | VariableT
}> = (Wrapped) => (props) => {
  if (props.variable.key === 'eFormType')
    return <Box component="div" sx={{ flex: 1 }} />
  return <Wrapped {...props} />
}
